/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustsuccess2Inputs */

const zh_adminsubs_adjustsuccess2 = /** @type {(inputs: Adminsubs_Adjustsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点数调整成功`)
};

const en_adminsubs_adjustsuccess2 = /** @type {(inputs: Adminsubs_Adjustsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits adjusted successfully`)
};

const es_adminsubs_adjustsuccess2 = /** @type {(inputs: Adminsubs_Adjustsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créditos ajustados con éxito`)
};

/**
* | output |
* | --- |
* | "Credits adjusted successfully" |
*
* @param {Adminsubs_Adjustsuccess2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustsuccess2 = /** @type {((inputs?: Adminsubs_Adjustsuccess2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustsuccess2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustsuccess2(inputs)
	if (locale === "en") return en_adminsubs_adjustsuccess2(inputs)
	return es_adminsubs_adjustsuccess2(inputs)
});
export { adminsubs_adjustsuccess2 as "adminSubs_adjustSuccess" }